'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressNotReadableModal = function AddressNotReadableModal(_ref) {
  var walletType = _ref.walletType,
      onBack = _ref.onBack,
      onRetry = _ref.onRetry;

  var instructions = void 0;
  if (walletType === 'browser') {
    instructions = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        'We were unable to read an active wallet/address from MetaMask.'
      ),
      _react2.default.createElement(
        'p',
        { className: 'secondary' },
        'Please check that you are logged in to MetaMask.'
      )
    );
  } else if (walletType === 'ledger') {
    instructions = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        'We were unable to communicate with your hardware wallet.',
        _react2.default.createElement('br', null),
        'Please check the following:'
      ),
      _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
          'li',
          null,
          'Your wallet is connected to your computer'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Your wallet is running the Ethereum app.'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Both the "Contract data" and "Browser support" settings are enabled in the Ethereum app settings.'
        )
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'address-not-readable-modal' },
    _react2.default.createElement(
      'h2',
      null,
      'Action Required'
    ),
    instructions,
    _react2.default.createElement(
      'div',
      { className: 'actions' },
      _react2.default.createElement(
        'button',
        { className: 'btn cancel', name: 'back', onClick: onBack },
        'Back'
      ),
      _react2.default.createElement(
        'button',
        { className: 'btn', name: 'retry', onClick: onRetry },
        'Retry'
      )
    )
  );
};

AddressNotReadableModal.defaultProps = {
  walletType: '',
  onBack: function onBack() {
    return null;
  },
  onRetry: function onRetry() {
    return Promise.resolve('');
  }
};

AddressNotReadableModal.propTypes = {
  walletType: _propTypes2.default.string,
  onBack: _propTypes2.default.func,
  onRetry: _propTypes2.default.func
};

exports.default = AddressNotReadableModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/AddressNotReadableModal.js
// module id = 1200
// module chunks = 0